import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { FormContext } from '../../context/form-context';

import growthIcon from '../../assets/images/dashboard/growth.svg';
import dietDiaperIcon from '../../assets/icons/learn/fluids-feeding.svg';
import visitationIcon from '../../assets/images/dashboard/visitation.svg';
import milestoneIcon from '../../assets/images/dashboard/bathing.svg';
import sleepIcon from '../../assets/icons/learn/nurturing.svg';

import './TrackerChooser.scss';

const TrackerChooser = ({
  showMilestoneModal = () => {},
  showDietDiaperModal = () => {},
  showGrowthModal = () => {},
  showActivitiesModal = () => {},
  showSleepModal = () => {},
  visible = false,
  setExpanded = () => {},
  setNoBabiesModal = () => {},
  babies = []
}) => {
  const { t } = useTranslation();
  const formContext = useContext(FormContext);

  useEffect(() => {
    if (babies.length === 0 && visible) {
      setExpanded(false);
      setNoBabiesModal(true);
    }
  }, [visible, babies.length, setExpanded, setNoBabiesModal]);

  const handleChoice = (modalTrigger) => {
    setExpanded(false);
    formContext.clearFormContext();
    modalTrigger();
  };

  return (
    <div
      className={classNames(
        'tracker-chooser-options',
        { '--open': visible }
      )}
    >
      <button
        type="button"
        className="tracker-chooser-button"
        onClick={() => handleChoice(showActivitiesModal)}
      >
        <div className="tracker-chooser-button__icon-container">
          <img className="tracker-chooser-button__icon" src={visitationIcon} alt="" />
        </div>
        <div className="tracker-chooser-button__title">
          {t('tracker.activities', 'Activities')}
        </div>
      </button>

      <button
        type="button"
        className="tracker-chooser-button"
        onClick={() => handleChoice(showSleepModal)}
      >
        <div className="tracker-chooser-button__icon-container">
          <img className="tracker-chooser-button__icon" src={sleepIcon} alt="" />
        </div>
        <div className="tracker-chooser-button__title">
          {t('tracker.sleep', 'Sleep')}
        </div>
      </button>

      <button
        type="button"
        className="tracker-chooser-button"
        onClick={() => handleChoice(showDietDiaperModal)}
      >
        <div className="tracker-chooser-button__icon-container">
          <img className="tracker-chooser-button__icon" src={dietDiaperIcon} alt="" />
        </div>
        <div className="tracker-chooser-button__title">
          {t('tracker.dietDiaper', 'Diet & Diaper')}
        </div>
      </button>

      <button
        type="button"
        className="tracker-chooser-button"
        onClick={() => handleChoice(showMilestoneModal)}
      >
        <div className="tracker-chooser-button__icon-container">
          <img className="tracker-chooser-button__icon" src={milestoneIcon} alt="" />
        </div>
        <div className="tracker-chooser-button__title">
          {t('tracker.milestones', 'Milestones')}
        </div>
      </button>

      <button
        type="button"
        className="tracker-chooser-button"
        onClick={() => handleChoice(showGrowthModal)}
      >
        <div className="tracker-chooser-button__icon-container">
          <img className="tracker-chooser-button__icon" src={growthIcon} alt="" />
        </div>
        <div className="tracker-chooser-button__title">
          {t('tracker.growth', 'Growth')}
        </div>
      </button>
    </div>
  );
};

TrackerChooser.propTypes = {
  showMilestoneModal: PropTypes.func,
  showDietDiaperModal: PropTypes.func,
  showGrowthModal: PropTypes.func,
  showActivitiesModal: PropTypes.func,
  showSleepModal: PropTypes.func,
  setExpanded: PropTypes.func,
  setNoBabiesModal: PropTypes.func,
  babies: PropTypes.array,
  visible: PropTypes.bool
};

export default TrackerChooser;
